export enum AccessToLearningProgramsEnum {
  None = 0,
  All = 1,
  Specific = 2,
}
